import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';

import BdsButton from '../../../../../shared/components/v3/Buttons/BdsButton/BdsButton';
import { CALENDAR_MONTH } from '../../../../../shared/constants/images';
import { CompanyContext } from '../../../../../shared/context/company/companyContext';
import { IChallenge, IChallengeInfo } from '../../../../../shared/interfaces/challenges';
import { TRANSLATION_CHALLENGES } from '../../../../../shared/translations/challenges';
import ChallengeDescriptionPreview from '../ChallengeDescription/sections/DescriptionPreview/ChallengeDescriptionPreview';

import './ChallengeReview.scss';

interface IChallengeReviewProps {
  setStep: (step: number) => void;
  setReturnToDate: (step: boolean) => void;
  icon: string;
  challenge: IChallenge;
  challegeInfo: IChallengeInfo;
  betterfliesRewarded: number;
}

const ChallengeReview = ({
  setStep,
  icon,
  challenge,
  betterfliesRewarded,
  challegeInfo,
  setReturnToDate
}: IChallengeReviewProps) => {
  const { locale } = useContext(CompanyContext);
  const timeLeft = new Date(challenge.endAt).getTime() - new Date(challenge.startAt).getTime();
  const daysLeft = Math.floor(timeLeft / (24 * 60 * 60 * 1000));
  const endDate = new Date(challenge.endAt).toLocaleDateString(locale);
  const { t } = useTranslation();

  return (
    <div className="wrap-up-challenge-section">
      <ChallengeDescriptionPreview
        title={challenge.name}
        description={challenge.description}
        daysLeft={daysLeft}
        rewardsPoints={betterfliesRewarded}
        circleIndicatorIconUrl={icon}
      />
      <div className="wrap-up-challenge-info">
        <div className="pc-top-left">
          <div className="pc-title">{t(TRANSLATION_CHALLENGES.createChallenge.challengeReview.challenge)}</div>
          <div className="pc-description">{t(TRANSLATION_CHALLENGES.detail.challengeType)}</div>
        </div>
        <div className="pc-top-right">
          <div className="pc-title">{t(TRANSLATION_CHALLENGES.createChallenge.challengeReview.activity)}</div>
          <div className="pc-description">{challegeInfo.title}</div>
        </div>
        <div className="pc-mid-left">
          <div className="pc-title">
            {t(TRANSLATION_CHALLENGES.createChallenge.challengeReview.goal, {
              challenge_type: challegeInfo.title.toLowerCase()
            })}
          </div>
          <div className="pc-description">{challenge.goal}</div>
        </div>
        <div className="pc-mid-right">
          <div className="pc-title">
            {t(TRANSLATION_CHALLENGES.createChallenge.challengeReview.betterflies, { count: betterfliesRewarded })}
          </div>
          <div className="pc-description">{betterfliesRewarded}</div>
        </div>
        <div className="pc-bottom-left">
          <div className="pc-title">{t(TRANSLATION_CHALLENGES.createChallenge.challengeReview.end)}</div>
          <div className="pc-bottom-buttons">
            <BdsButton
              action={() => {
                setStep(1);
                setReturnToDate(true);
              }}
              variant="variable"
              size="l"
              iconLeft={CALENDAR_MONTH}
            >
              {endDate}
            </BdsButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeReview;
